module.exports = __webpack_public_path__ + "static/img/one.92c70b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/11/one.png
// module id = Nh4I
// module chunks = 1